import { render, staticRenderFns } from "./billing-grid-actions-copayments.vue?vue&type=template&id=2c7e3a6c&scoped=true&"
import script from "./billing-grid-actions-copayments.ts?vue&type=script&lang=ts&"
export * from "./billing-grid-actions-copayments.ts?vue&type=script&lang=ts&"
import style0 from "./billing-grid-actions-copayments.scss?vue&type=style&index=0&id=2c7e3a6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7e3a6c",
  null
  
)

export default component.exports